import dayjs from 'dayjs';

const formatDay = (v) => (v ? dayjs(v).format('YYYY-MM-DD') : undefined);
const formatDayOrUndef = (v) => (v ? (v.format ? v.format('YYYY-MM-DD') : formatDay(v)) : undefined);

export const splitRange = (item, rangeKey, fromKey, toKey) => {
  if (!item) return item;
  const range = item[rangeKey];
  const { [rangeKey]: _range, ...rest } = item;
  const [from, to] = Array.isArray(range) ? range : [];
  return {
    ...rest,
    [fromKey]: formatDayOrUndef(from),
    [toKey]: formatDayOrUndef(to),
  };
};

export const transformOccupation = (item) => splitRange(item, 'OCCDATE', 'OCCFROM', 'OCCTO');
export const transformEducation = (item) => splitRange(item, 'ENRDATE', 'ENRFROM', 'ENRTO');

const workdayTransform = (v) => {
  if (v === '0' || v === 0) return ['0', '1', '2', '3', '4'];
  if (v === '1' || v === 1) return ['5', '6'];
  return undefined;
};

/**
 * 把前端结构化的意图列表, 转成后端期望的扁平结构.
 *
 * 数据约定 (v2 - 对象归一化):
 *   - item.JOBTYPE  始终是 { name, value } 单值对象 (前端唯一真值来源)
 *   - item.DISTRICT  始终是 { name, value } 单值对象 (前端唯一真值来源)
 *   提交时分别取 .value, 包成后端要求的 [value] 数组.
 *
 * 选择器 (JobSelectModal / AreaSelectModal) 走 onConfirm 返回原始对象,
 * IntentionModule 直接把这个对象写进 item, 不再需要 selectedJobs/selectedAreas
 * 平行 state. 此函数签名上保留 selectedJobs/selectedAreas 是为了向后兼容老
 * 单元测试 — 优先级: item 里的对象 > 平行 state > 空数组.
 */
export const buildIntention = (intentions = [], selectedJobs = [], selectedAreas = []) => intentions.map((item, idx) => {
  // JOBTYPE: 优先级 item.JOBTYPE 对象 > 平行 state > 空
  let jobTypeValue;
  const itemJob = item.JOBTYPE;
  if (itemJob && typeof itemJob === 'object' && (itemJob.value || itemJob.code)) {
    jobTypeValue = itemJob.value || itemJob.code;
  } else if (selectedJobs[idx] && (selectedJobs[idx].code || selectedJobs[idx].value)) {
    jobTypeValue = selectedJobs[idx].code || selectedJobs[idx].value;
  }

  // DISTRICT: 优先级 item.DISTRICT 对象 > 平行 state 数组 > 空
  let districtValues = [];
  const itemDistrict = item.DISTRICT;
  if (itemDistrict && typeof itemDistrict === 'object' && !Array.isArray(itemDistrict) && (itemDistrict.value || itemDistrict.code)) {
    districtValues = [itemDistrict.value || itemDistrict.code];
  } else if (Array.isArray(selectedAreas[idx]) && selectedAreas[idx].length > 0) {
    districtValues = selectedAreas[idx].map((d) => d.value || d.code).filter(Boolean);
  }

  const worktimeArr = Array.isArray(item.WORKTIME) ? item.WORKTIME : [];
  return {
    ...(item.id ? { id: item.id } : {}),
    JOBTYPE: jobTypeValue ? [jobTypeValue] : [],
    PROPERTY: item.PROPERTY ? [String(item.PROPERTY)] : [],
    AWS: item.AWS !== undefined && item.AWS !== null ? Number(item.AWS) : undefined,
    DISTRICT: districtValues,
    SALFROM: String(item.SALFROM || 0),
    SALTO: String(item.SALTO || 0),
    WORKDAY: workdayTransform(item.WORKDAY),
    WORKTIME: worktimeArr.length > 0 ? worktimeArr : undefined,
  };
});

export const normalizeIntentionsFromServer = (list = []) => list.map((it) => {
  const workday = it.WORKDAY || [];
  const workdaySingle = workday.includes('5') || workday.includes('6') ? '1' : (workday.length > 0 ? '0' : undefined);
  // 后端返回 [{ name, value }]; 取数组第一个位置的整个对象, 保留 name+value 供前端取用
  const firstJob = (it.JOBTYPE || [])[0];
  const firstDistrict = (it.DISTRICT || [])[0];
  return {
    id: it.id,
    PROPERTY: it.PROPERTY && it.PROPERTY[0] ? it.PROPERTY[0].value : undefined,
    JOBTYPE: firstJob ? { name: firstJob.name, value: firstJob.value || firstJob.code } : undefined,
    DISTRICT: firstDistrict ? { name: firstDistrict.name, value: firstDistrict.value || firstDistrict.code } : undefined,
    SALFROM: it.SALFROM,
    SALTO: it.SALTO,
    AWS: it.AWS,
    WORKDAY: workdaySingle,
    WORKTIME: it.WORKTIME || [],
  };
});

export const buildBaseInfoParams = (values) => ({
  PERNAME: values.PERNAME,
  SEX: values.SEX,
  CELL: values.CELL,
  EMAIL: values.EMAIL,
  BRTHDATE: formatDayOrUndef(values.BRTHDATE),
  STLDISTRICT: values.STLDISTRICT,
  STLNAT: values.STLNAT,
  RESADDRESS: values.RESADDRESS,
  PROFILE: values.PROFILE,
  EDU: values.EDU,
  WKDATE: formatDayOrUndef(values.WKDATE),
  STATUS: values.STATUS,
});
